<template>
  <div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import _ from 'lodash'

export default {
  data () {
    return {
      markers: {},
      isMarkerInitialized: false,
      isSoptsInitialized: false,
      markerCluster: {},
      sectedPlaceId: null,
      showFilter: {}
    }
  },
  methods: {
    isMapInitialized: function () {
      return !_.isEmpty(this.map) && this.google !== null && this.genres !== null && this.genres.length > 0
    },
    getVisible: function (genreIds) {
      const genre = this.genres.filter(g => genreIds.includes(g.id))
      const visible = genre.filter(g => this.filter[g.id])
      return visible.length > 0 ? true : false
    },
    setMarker: function () {
      if (this.isMapInitialized() && this.places !== null && !this.isMarkerInitialized) {
        this.isMarkerInitialized = true
        this.genres.forEach(g => {
          this.markers[g.id] = []
        })
        this.places.forEach(p => {
          const marker = new this.google.maps.Marker({
              position: {
                  lat: p.location.latitude, lng: p.location.longitude
              },
              title: String(p.id),
              map: this.map,
              icon: this.icon(p),
              zIndex: this.zIndex(p),
              visible: this.getVisible(p.genreIds)
          })
          this.google.maps.event.addListener(marker, "click", () => {
            this.$store.dispatch('busLocation/close')
            this.onMarkerSelected(p)
          })
          this.markers[p.genreIds[0]].push(marker)
        })
        this.genres.forEach(g => {
          if (this.getTextColor(g.id) !== undefined) {
              this.setPlaceMarkerCluster(g.id, this.markers[g.id])
          }
        })
      }
    },
    setPlaceMarkerCluster: function (id, markers) {
      // マーカーの表示
      this.setMarkerVisible(markers)
      // マーカークラスターの定義
      const styles = [{
        url: require('@/assets/images/mapmarker/cluster_' + id + '.png'),
        height: 28,
        width: 28,
        anchorText: [0, 0],
        textColor: this.getTextColor(id),
        textSize: 12
      }]
      this.markerCluster[id] = new window.MarkerClusterer(this.map, markers.filter(m => m.getVisible()), {
          styles: styles,
          enableRetinaIcons: true,
          gridSize: 30
      })
    },
    setMarkerVisible: function (markers) {
      for (let i = 0; i < markers.length; i++) {
        const p = this.places.find(p => String(p.id) == markers[i].title)
        markers[i].setVisible(this.getVisible(p.genreIds))
      }
    },
    getTextColor: function (id) {
      switch (id) {
        default:
          return '#000000'
        }
    },
    setStopsMarker: function () {
      if (this.isMapInitialized() && this.google !== null && !this.isSoptsInitialized && this.stops !== undefined) {
        this.isSoptsInitialized = true
        const id = 'buslocation'
        this.markers[id] = []
        for (let i = 0; i < this.stops.length; i++) {
          const marker = new this.google.maps.Marker({
              position: {
                  lat: this.stops[i].lat, lng: this.stops[i].lon
              },
              title: this.stops[i].stopId,
              map: this.map,
              icon: {
                url: require('@/assets/images/mapmarker/busstop.png'),
                scaledSize: new this.google.maps.Size(36, 36)
              },
              zIndex: this.zIndex(this.stops[i]),
              visible: this.filter.buslocation
          })
          this.google.maps.event.addListener(marker, "click", () => {
            this.$store.dispatch('drawer/close')
            this.$store.dispatch('busLocation/updateSelectedStops', [this.stops[i]])
            const params = {
              lat: this.stops[i].lat,
              lng: this.stops[i].lon
            }
            this.$store.dispatch('map/updateCenter', params)
          })
          this.markers[id].push(marker)
        }
        if (this.filter.buslocation) {
          this.setBusMarkerCluster('buslocation')
        }
      }
    },
    setBusMarkerCluster: function (id) {
      // マーカーの表示
      for (let i = 0; i < this.markers[id].length; i++) {
        this.markers[id][i].setVisible(true)
      }
      // マーカークラスターの定義
      const styles = [{
        url: require('@/assets/images/mapmarker/cluster_' + id + '.png'),
        height: 36,
        width: 36,
        anchorText: [-4, 0],
        textColor: this.getTextColor(id),
        textSize: 12
      }]
      this.markerCluster[id] = new window.MarkerClusterer(this.map, this.markers[id], {
          styles: styles,
          enableRetinaIcons: true,
          gridSize: 30
      })
      // 選択済みバス停のリスナー
      this.google.maps.event.addListener(this.markerCluster["buslocation"], 'click', (cluster) => {
        if (cluster.getMarkers().length <= 8) {
          this.$store.dispatch('drawer/close')
          var stops = []
          for (var i = 0; i < cluster.getMarkers().length; i++) {
            var busStop = this.stops.find(busStop => busStop.stopId == cluster.getMarkers()[i].title);
            stops.push(busStop)
          }
          this.$store.dispatch('busLocation/updateSelectedStops', stops)
        }
      })
    },
    setFilter: function () {
      if (_.isEmpty(this.markerCluster)) {
        this.genres.forEach(g => {
          if (this.markers[g.id]!== undefined) {
            this.setPlaceMarkerCluster(g.id, this.markers[g.id])
          }
        })
      }
      for (let genreId in this.filter) {
        if (this.showFilter[genreId] === undefined || this.showFilter[genreId] !== this.filter[genreId]) {
          this.showFilter[genreId] = this.filter[genreId]
          if (this.markers[genreId] !== undefined) {
            if (genreId === 'buslocation' && this.isSoptsInitialized) {
            this.markers[genreId].forEach(m => {
              m.setVisible(this.showFilter[genreId])
            })
            if (this.showFilter[genreId]) {
              if (this.markerCluster[genreId] !== undefined) {
                this.markerCluster[genreId].addMarkers(this.markers[genreId])
              } else {
                this.setBusMarkerCluster(genreId)
              }
            } else if (this.markerCluster[genreId] !== undefined) {
              this.markerCluster[genreId].clearMarkers()
            }
          } else if (this.isMarkerInitialized && this.getTextColor(genreId) !== undefined) {
            this.markers[genreId].forEach(m => {
              m.setVisible(this.showFilter[genreId])
            })
            if (this.showFilter[genreId]) {
              if (this.markerCluster[genreId] !== undefined) {
                this.markerCluster[genreId].clearMarkers()
                this.setPlaceMarkerCluster(genreId, this.markers[genreId])
              } else {
                this.setPlaceMarkerCluster(genreId, this.markers[genreId])
              }
            } else if (this.markerCluster[genreId] !== undefined) {
              this.markerCluster[genreId].clearMarkers()
              this.setPlaceMarkerCluster(genreId, this.markers[genreId])
            } else {
              this.setPlaceMarkerCluster(genreId, this.markers[genreId])
            }
          }

          }
        } else {
          if (this.markerCluster[genreId] !== undefined) { 
            this.markerCluster[genreId].clearMarkers()
            this.setPlaceMarkerCluster(genreId, this.markers[genreId])
          }
        }
      }
    },
    onMarkerSelected: function (place) {
      this.$store.dispatch('drawer/openPlace', { place: place, full: false })
      this.$store.dispatch('drawer/showButton')
    },
    icon: function (place) {
      if (this.google) {
        let size = new this.google.maps.Size(36, 36)
        if (this.selectedPlace && place.id === this.selectedPlace.id) {
          size = new this.google.maps.Size(62, 62)
        }
        return {
          url: this.iconPath(place),
          scaledSize: size
        }
      }
    },
    iconPath(place) {
      if (place.mapIcon !== undefined && place.mapIcon.length > 0) {
        return place.mapIcon
      } else if (this.$store.getters['genres/getMapIcon'](place) !== undefined && this.$store.getters['genres/getMapIcon'](place).filterIcon !== undefined) {
        return this.$store.getters['genres/getMapIcon'](place).filterIcon
      } else {
        return require('@/assets/images/place-24px.svg')
      }
    },
    zIndex(place) {
      if (place.priority !== undefined){
        return 50 - place.priority
      } else {
        return 1
      }
    },
    mapInitialized: function () {
      this.setMarker()
    }
  },
  computed: {
    ...mapGetters({
      map: 'googleMap/getMap',
      filter: 'user/getFilter',
      selectedPlace: 'drawer/getSelectedPlace',
      genres: 'genres/getAll',
      places: 'places/getPlaces',
      stops: 'busLocation/getStops'
    }),
    google: gmapApi
  },
  watch: {
    filter: {
      handler: function () {
        this.setFilter()
      },
      deep: true
    },
    stops: function () {
      this.setStopsMarker()
    },
    google: function () {
      this.setMarker()
      this.setStopsMarker()
    },
    selectedPlace: function () {
      if (this.sectedPlaceId !== null) {
        const place = this.places.find(p => p.id == this.sectedPlaceId)
        const genreId = place.genreIds[0]
        if (this.markerCluster[genreId] !== undefined) {
          const marker = this.markers[genreId].find(m => m.title == String(this.sectedPlaceId))
          marker.setIcon(this.icon(place))
          this.markerCluster[genreId].addMarker(marker)
        }
      }
      if (_.isEmpty(this.selectedPlace)) {
        this.sectedPlaceId = null
      } else {
        const index = this.places.findIndex(place => place.id === this.selectedPlace.id)
        if (index !== -1) {
          this.sectedPlaceId = this.selectedPlace.id
          const genreId = this.selectedPlace.genreIds[0]
          if (this.markerCluster[genreId] !== undefined) {
            const marker = this.markers[this.selectedPlace.genreIds[0]].find(m => m.title == this.selectedPlace.id)
            this.markerCluster[genreId].removeMarker(marker)
            // マップ上に表示
            marker.setMap(this.map)
            // アイコンのサイズ変更
            marker.setIcon(this.icon(this.selectedPlace))
          }
        }
      }
    }
  }
}
</script>
